module.exports = __webpack_public_path__ + "static/img/products_iLab.6422db01.png";